export enum UserStatusesEnum
{
    active = "Active",
    inactive = "Inactive",
    invited = "Invited",
}
